// extracted by mini-css-extract-plugin
export var burgerButton = "header-module--burgerButton--f4062";
export var headerWrapper = "header-module--headerWrapper--6b350";
export var mainLogo = "header-module--mainLogo--8ce1c";
export var menuBlock = "header-module--menuBlock--39518";
export var mobileMenu = "header-module--mobileMenu--4ec02";